import { Box, Fade, Image } from "@chakra-ui/react";
import { FC, useEffect, useRef } from "react";
import "swiper/css";
import "swiper/css/pagination";
import useScreen from "../../hooks/useScreen";
import styles from "./ProcessingImage.module.css";

import SwiperCore, { Pagination } from "swiper";
import { HairTipsCarousel } from "../HairTipsCarousel/HairTipsCarousel";
SwiperCore.use([Pagination]);

interface ProcessingImageProps {
  vto?: string;
}

export const ProcessingImage: FC<ProcessingImageProps> = (props) => {
  const { isMobile } = useScreen();
  const swiperRef = useRef<SwiperCore>();

  useEffect(() => {
    const interval = setInterval(() => swiperRef.current?.slideNext(), 5000);
    return () => clearInterval(interval);
  }, []);

  return (
    <Fade in={true} style={{ zIndex: 10001, position: "absolute" }}>
      <Box
        bg={{ base: "rgba(204, 0, 88, 0.96)" }}
        position="fixed"
        top={0}
        w="100%"
        h="100%"
        display="flex"
        alignItems="center"
        justifyContent="center"
        flexDirection="column"
        gap="7rem"
      >
        <Box>
          <Box
            w="170px"
            h="170px"
            bg="#D689AB"
            display="flex"
            alignItems="center"
            justifyContent="center"
            borderRadius="100%"
            position="relative"
            className="pulse"
          >
            <Box className={styles.ring}></Box>
            <Box className={styles.ring}></Box>
            <Box className={styles.ring}></Box>
            <Box className={styles.ring}></Box>
          </Box>

          <Box
            top="-25%"
            left="50%"
            transform="translate(-50%, -50%)"
            w="170px"
            h="170px"
            display="flex"
            alignItems="center"
            justifyContent="center"
            borderRadius="100%"
            position="relative"
          >
            <Image
              src={process.env.PUBLIC_URL + "/assets/images/hairdryer.gif"}
              alt="Hairdryer"
              height={"85px"}
            />
          </Box>
          <Box position="fixed" w="100%" zIndex={100} left="0%" top="65%">
            <HairTipsCarousel place="processing-image" {...props} />
          </Box>
        </Box>
      </Box>
    </Fade>
  );
};
